import { useState } from 'react';
import { useTheme } from '@mui/system';
import MainCard from 'ui-component/cards/MainCard';
import { Guidelines } from './pages/Guidelines';
import { Box, Button, Grid, LinearProgress } from '@mui/material';
import { PictureAsPdf } from '@mui/icons-material';
import FirebaseStorageService from 'firebaseService/firebaseStorage';

export const GuidelinesPage = () => {
  const [isLoading, setLoading] = useState(false);
  const theme = useTheme();

  const downloadURL = async () => {
    const path = 'formatos/Lineamientos LGMDE.pdf';
    try {
      setLoading(true);
      const url = await FirebaseStorageService.downloadFile(path);
      window.open(url, '_blank');
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <MainCard style={{ marginTop: '20px', paddingBottom: '5px' }} className="animate__animated animate__fadeIn">
        <Guidelines />
        {isLoading && <LinearProgress />}
        <Grid container justifyContent={'center'}>
          <Box>
            <Button variant="outlined" onClick={downloadURL} endIcon={<PictureAsPdf color={theme.palette.grey[500]} />}>
              Descargar documento.
            </Button>
          </Box>
        </Grid>
      </MainCard>
    </>
  );
};
